module.exports = __webpack_public_path__ + "img/4-1_04.fae2d644.jpg";